import NotificationsTypes from 'redux/notifications/types';

const initialState = {
  notifications: { data: [] },
  pageNumberFetched: 1,
  fetchingNotifications: true,
  readingNotification: false,
  deletingNotification: false,

  newNotifications: 0,
  fetchingNewNotifications: true,

  openingNewNotifications: false,
};

function notificationReducer(state = initialState, { type, payload }) {
  switch (type) {
    // Fetch Notifications
    case NotificationsTypes.FETCH_NOTIFICATION:
      return {
        ...state,
        fetchingNotifications: true,
      };
    case NotificationsTypes.FETCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        fetchingNotifications: false,
        notifications: payload,
        pageNumberFetched: 1,
      };
    case NotificationsTypes.FETCH_NOTIFICATION_FAILURE:
      return {
        ...state,
        fetchingNotifications: false,
      };

    // Fetch More Notifications
    case NotificationsTypes.FETCH_MORE_NOTIFICATION:
      return {
        ...state,
        fetchingNotifications: true,
      };
    case NotificationsTypes.FETCH_MORE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        fetchingNotifications: false,
        notifications: {...payload, data: [...state.notifications.data, ...payload.data]},
        pageNumberFetched: state.pageNumberFetched + 1,
      };
    case NotificationsTypes.FETCH_MORE_NOTIFICATION_FAILURE:
      return {
        ...state,
        fetchingNotifications: false,
      };

    // new Notifications
    case NotificationsTypes.FETCH_NEW_NOTIFICATIONS:
      return {
        ...state,
        fetchingNewNotifications: true,
      };
    case NotificationsTypes.FETCH_NEW_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        fetchingNewNotifications: false,
        newNotifications: payload,
      };
    case NotificationsTypes.FETCH_NEW_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        fetchingNewNotifications: false,
      };

      // Open New Notifications
      case NotificationsTypes.OPEN_NEW_NOTIFICATIONS:
      return {
        ...state,
        openingNewNotifications: true,
      };
    case NotificationsTypes.OPEN_NEW_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        openingNewNotifications: false,
        newNotifications: 0,
      };
    case NotificationsTypes.OPEN_NEW_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        openingNewNotifications: false,
      };

    // Read Notifications
    case NotificationsTypes.READ_NOTIFICATION:
      return {
        ...state,
        readingNotification: true,
      };
    case NotificationsTypes.READ_NOTIFICATION_SUCCESS:
      return {
        ...state,
        readingNotification: false,
        notifications: {
          ...state.notifications,
          data: state.notifications.data.map((n) => {
            if (payload.id === n.id) {
              return {
                ...payload,
                read: !payload.read,
              };
            }
            return n;
          }),
        },
      };
    case NotificationsTypes.READ_NOTIFICATION_FAILURE:
      return {
        ...state,
        readingNotification: false,
      };

    // Delete Notifications
    case NotificationsTypes.DELETE_NOTIFICATION:
      return {
        ...state,
        deletingNotification: true,
      };
    case NotificationsTypes.DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        deletingNotification: false,
        notifications: state.notifications.map((n) => n),
      };
    case NotificationsTypes.DELETE_NOTIFICATION_FAILURE:
      return {
        ...state,
        deletingNotification: false,
      };

    default:
      return state;
  }
}

export default notificationReducer;
